import { Injectable } from '@angular/core'; 
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs'; 
import { GLOBAL } from './global';

@Injectable({
  providedIn: 'root'
})
export class FacturacionService {

	public url: string;
	
	constructor(
		public _http: HttpClient
	) { 
		this.url = GLOBAL.url; 
	}

	getDatosDeFacturacion(token, id): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', token);
		return this._http.get(this.url+'datosdefacturacion/'+id, {headers: headers});
	}

	createFacturacion(token, facturacion): Observable<any>{
		let json = JSON.stringify(facturacion);
		let params = 'json='+json;

		let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', token);
		return this._http.post(this.url+'datosdefacturacion', params, {headers: headers});
	}

	update(token, id, facturacion): Observable<any>{
		let json = JSON.stringify(facturacion);
		let params = 'json='+json;

		let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', token);
		return this._http.put(this.url+'datosdefacturacion/'+id, params, {headers: headers});
	}
}
